import React from 'react';
import TileGroup from './TileGroup';
import ProfessionalForeignObject from './ProfessionalForeignObject';

interface ComponentConfig {
    component: React.ComponentType<any>;
    props: {
        cx?: number;
        cy?: number;
        r?: number;
        tx?: number;
        ty?: number;
        texture?: string;
    };
    key: string;
}

interface ProfessionalProps {
    specialTiles: ComponentConfig[];
    facadeTiles: [number, number][];
    groupCoordinates: [number, number][];
}

const Professional: React.FC<ProfessionalProps> = ({ specialTiles, facadeTiles, groupCoordinates }) => {
    return (
        <TileGroup
            specialTiles={specialTiles}
            facadeTiles={facadeTiles}
            groupCoordinates={groupCoordinates}
            groupName="professional"
            displayText="PROFESSIONAL"
            backgroundTexture="/textures/stone_bricks.png"
            foreignObjectComponent={ProfessionalForeignObject}
            zoomScale={2.5}
        />
    );
};

export default Professional;